import {Box, useMediaQuery, useTheme} from "@mui/material";

const CompanyDetailGrid = ({children}) => {
  const theme = useTheme();
  const matchesLg = useMediaQuery(theme.breakpoints.up('cdLg'));
  const matchesMd = useMediaQuery(theme.breakpoints.up('cdMd'));

  let gridTemplateColumns, gridTemplateAreas;

  if (matchesLg) {
    gridTemplateColumns = '1fr 1fr 1fr'
    gridTemplateAreas =
      `"location      classification similar"
       "contact       people         similar"
       "descriptive   socioeconomic  similar"
       "incorporation socioeconomic  franchise"
       "metrics       metrics        metrics"`
  } else if (matchesMd) {
    gridTemplateColumns = 'repeat(2, 1fr)'
    gridTemplateAreas =
      `"location      classification"
       "contact       similar"
       "descriptive   similar"
       "people        similar"
       "incorporation socioeconomic"
       "franchise     franchise"
       "metrics       metrics"`
  } else {
    gridTemplateColumns = '1fr'
    gridTemplateAreas = `"location"
       "contact"
       "classification"
       "descriptive" 
       "similar"
       "people"
       "incorporation"
       "socioeconomic"
       "franchise"
       "metrics"`
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: gridTemplateColumns,
        gridTemplateRows: 'auto',
        gap: 0,
        gridTemplateAreas: gridTemplateAreas,
      }}
    >
      {children}
    </Box>)
}

export default CompanyDetailGrid